module.exports = __webpack_public_path__ + "img/IMG-8801.96db117d.jpg";